import { Grid } from "@mui/material"
import { CardElement } from "../types"
import Card from "../Card/Card"

const ProjectsList = ({ data }: {
    data: CardElement[]
}) => {
    return (
        <Grid 
            container 
            spacing={10} 
            justifyContent="center" 
            style={{ 
            overflowY: "auto", 
            maxHeight: "85%", 
            scrollbarWidth: "none",
            msOverflowStyle: "none"
            }}
        >
            {data.map(element => (
            <Grid key={element.id} sx={{ display: "block" }}>
                <Card
                id={element.id}
                title={element.title}
                description={element.description}
                image={element.image}
                address={element.address}
                repository={element.repository}
                />
            </Grid>
            ))}
        </Grid>
    )
}

export default ProjectsList